import { forEach } from "lodash";
import { IServiceProvider } from "./modules.types";
import { map, prop, props } from "ramda";

export const createServiceProvider: () => IServiceProvider = () =>{
  const _services = new Map<string, any>();

  const printConfig = {
    keys: [() => _services.keys(), "Printing keys:"],
    values: [() => _services.values(), "Printing values:"],
    all: [() => _services.entries(), "Printing all:"],
  }
  const print = (type: "all"|"keys"|"values") => {
    const it = (printConfig[type][0] as any)();
    map(console.log,(Array.from(it)));
  }

  return {
    has: (key: string) => {
      return _services.has(key);
    },
    register: (key: string, service: any) => {
      _services.set(key, service);
    },
    resolve<T>(key: string): T{
      if(_services.has(key)){
        return _services.get(key);
      }
      else{
        throw new Error(`Key not found in service provider: ${key}`);
      }
    },
    update<T=any>(key: string, instance:T){
      if(_services.has(key)){
        _services.set(key, instance);
      }
      else{
        throw new Error(`Key not found in service provider: ${key}`);
      }
    },
    unregister(key: string){
      _services.delete(key);
    },
    printAll: () => print("all"),
    printKeys: () => print("keys"),
    printValues: () => print("values"),
    getAll: (filter?: ((a: any) => boolean)) => {
      const all = Array.from(_services.values());
      if(filter){
        return all.filter(filter);
      }
      return all;
    }
  }
}
